import { HttpClient, HttpStatusCode } from 'data/protocols/http';
import { InvalidCredentialsError, UnexpectedError } from 'domain/errors';
import { Menu } from 'domain/models';
import { GetMenu } from 'domain/usecases';

export class RemoteGetMenu implements GetMenu {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<Menu[]>,
  ) {}

  async execute(): Promise<Menu[]> {
    const httpResponse = await this.httpClient.request({
      method: 'get',
      url: this.url,
    });

    switch (httpResponse.statusCode) {
      case HttpStatusCode.ok:
        return httpResponse.body;
      case HttpStatusCode.forbidden:
        throw new InvalidCredentialsError();
      default:
        throw new UnexpectedError();
    }
  }
}
